import {
  CylinderGeometry,
  IcosahedronGeometry,
  Mesh,
  MeshLambertMaterial,
  Object3D,
} from 'three';
import { randFloat } from '../utils/random';

/** Low-poly cartoon tree, used to dress the parks. */
export function addTree(parent: Object3D, x: number, z: number, groundY: number): void {
  const trunkHeight = randFloat(2.6, 3.6);
  const trunk = new Mesh(
    new CylinderGeometry(0.22, 0.32, trunkHeight, 6),
    new MeshLambertMaterial({ color: 0x7a4a23 }),
  );
  trunk.position.set(x, groundY + trunkHeight / 2, z);
  trunk.castShadow = true;
  parent.add(trunk);

  const leaves = new Mesh(
    new IcosahedronGeometry(randFloat(1.6, 2.4), 0),
    new MeshLambertMaterial({ color: 0x4fae42 }),
  );
  leaves.position.set(x, groundY + trunkHeight + 0.7, z);
  leaves.castShadow = true;
  parent.add(leaves);
}
